export function enumToOptions(enumeration: any, prefix: string = '') {
    return Object.values(enumeration).map((it) => ({
        name: `${prefix}${it}`,
        value: it,
    }));
}

export function enumNumbersToOptions(enumeration: any, prefix: string = '') {
    return Object.keys(enumeration)
        .filter(key => isNaN(Number(key)))
        .map(key => ({
            name: `${prefix}${key}`,
            value: enumeration[key],
        }));
}

export function arrayToOptions(values: string[], prefix: string = '') {
    return values.map((it) => ({
        name: `${prefix}${it}`,
        value: it,
    }));
}

export function enumToArray(enumeration: any, prefix: string = '') {
    return Object.values(enumeration).map((it) => `${prefix}${it}`);
}
